import { useIncomeDetails } from '../useIncomeDetails'

export const useRecurringIncome = () => {
  const { data, isLoading, isError } = useIncomeDetails()
  return { data: data?.recurringIncomes ?? [], isLoading, isError }
}
